import React from "react";
import "./Sidebar.scss";
import classNames from "classnames";

interface SidebarContainerProps {
  children?: React.ReactNode;
  isSidebarOpen: boolean;
}

export const SidebarContainer: React.FC<SidebarContainerProps> = ({
  children,
  isSidebarOpen,
}: SidebarContainerProps) => {
  return (
    <div
      className={classNames("sidebar", { "sidebar--closed": !isSidebarOpen })}
    >
      {children}
    </div>
  );
};
